import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "./redux/membershipLengthSagas";
import LoadingAnimation from "../../../../components/loadingAnimation/loadingAnimation";
import ReactDatePicker from "../../../../components/reactDatePicker/reactDatePicker";
import MembershipLengthLearnMore from "./smartComponents/MembershipLengthLearnMore";
import SectionToggle from "../../../../components/sectionToggle/sectionToggle";
import AgreementStatusFilter from "./smartComponents/AgreementStatusFilter";
import ModuleLogicSwitcher from "./smartComponents/ModuleLogicSwitcher";
import SalesPackageFilter from "./smartComponents/SalesPackageFilter";
import MemberStatusFIlter from "./smartComponents/MemberStatusFIlter";
import MembershipTypes from "./smartComponents/MembershipTypes";
import PieChart from "../../../../components/pieChart/pieChart";
import AgreementTable from "./smartComponents/AgreementTable";
import CategoryFilter from "./smartComponents/CategoryFilter";
import GroupByFilter from "./smartComponents/GroupByFilter";
import { UpdateBtns } from "./smartComponents/UpdateBtns";
import { DataPoints } from "./smartComponents/DataPoints";
import Type from "./smartComponents/Type";
import "./membershipLength.scss";

import { MODULE_LOGICS } from "./constants";

const MembershipLengthModule = (props) => {
  const dispatch = useDispatch();
  const { updatesLoading, initialRequest, isLoading } = useSelector(
    (state) => state.membershipLengthByAgreement
  );
  const { useSecondaryCategories } = useSelector((state) => state.commonReducer.commonProps);
  const typeFilter = useSelector(
    (state) => state.membershipLengthByAgreement.selectedFilters.type.id
  );
  const selectedModuleLogic = useSelector(
    (state) => state.membershipLengthByAgreement.selectedModuleLogic.id
  );
  const pie_charts = useSelector((state) => state.membershipLengthByAgreement.table.pie_charts);
  const hasSelectedAgreementLogic = selectedModuleLogic === MODULE_LOGICS.AGREEMENTS;

  useEffect(() => {
    if (!initialRequest) {
      dispatch(actionCreators.fetchCurrentUser(props));
    }
  }, []);

  const content = () => {
    return (
      <div>
        <div id="override-edit-selection-bar" className="edit-selections-bar">
          <div className="top-filter">
            <div>
              {hasSelectedAgreementLogic ? (
                <>
                  <AgreementStatusFilter />
                  <Type />
                  {typeFilter === "membership_type" ? (
                    <MembershipTypes />
                  ) : useSecondaryCategories ? (
                    <>
                      <CategoryFilter />
                      <SalesPackageFilter />
                      <GroupByFilter />
                    </>
                  ) : (
                    <SalesPackageFilter />
                  )}
                </>
              ) : (
                <MemberStatusFIlter />
              )}
            </div>
            <ReactDatePicker
              calendarEndDate={props.calendarEndDate}
              disabled
              startDate={props.calendarEndDate}
            />
            <UpdateBtns params={props} />
          </div>
        </div>

        {updatesLoading ? (
          <LoadingAnimation text="Updating data..." />
        ) : pie_charts?.length ? (
          <>
            <div className={`chart-container ${hasSelectedAgreementLogic ? "" : "double-charts"}`}>
              <DataPoints />
              <div className="pie-charts">
                {pie_charts.map((chart, idx) => (
                  <div key={chart.title || idx} className="pie-chart">
                    {chart?.title && <h5 className="pie-chart__title">{chart.title}</h5>}
                    <PieChart
                      width={600}
                      isSortable={false}
                      showPercent
                      height={hasSelectedAgreementLogic ? 300 : 350}
                      customTooltip
                      responsive={false}
                      data={chart.data}
                      showLegend
                      isLegendTooltip
                      legendPosition="right"
                    />
                  </div>
                ))}
              </div>
            </div>
            <AgreementTable />
          </>
        ) : (
          <p className="error">No data available</p>
        )}
      </div>
    );
  };
  return (
    <div id="membershipLength">
      <SectionToggle
        title="Membership Length by"
        isLoading={isLoading}
        content={content()}
        autoHeight
        learnMore={
          <>
            <ModuleLogicSwitcher />
            <MembershipLengthLearnMore logic={selectedModuleLogic} />
          </>
        }
      />
    </div>
  );
};

export default React.memo(MembershipLengthModule);
